
import React from 'react';
import { format, isToday } from 'date-fns';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import DailyTile, { MealInfo } from '@/components/ui/daily-tile';

interface ShoppingListTileProps {
  date: Date;
  isSelected: boolean;
  hasMealPlan: boolean;
  mealPlans: Array<{ 
    type: 'recipe' | 'composition';
    id: string;
    name: string;
    recipeIds?: string[];
    isQuickRecipe?: boolean;
    mealType: string;
    authorFirstName?: string;
    imageUrl?: string;
    storageImageUrl?: string;
    userImageUrl?: string;
    storageImagePath?: string;
    userImagePath?: string;
  }> | null;
  onToggle: (date: Date) => void;
}

const ShoppingListTile: React.FC<ShoppingListTileProps> = ({
  date,
  isSelected,
  hasMealPlan,
  mealPlans,
  onToggle,
}) => {
  // Convert meal plans to MealInfo format and filter out notes (only recipes and compositions for shopping)
  const meals: MealInfo[] = mealPlans ? mealPlans
    .filter(mealPlan => mealPlan.type === 'recipe' || mealPlan.type === 'composition')
    .map(mealPlan => ({
      type: mealPlan.type,
      id: mealPlan.id,
      name: mealPlan.name,
      isQuickRecipe: mealPlan.isQuickRecipe,
      recipeCount: mealPlan.recipeIds?.length,
      mealType: mealPlan.mealType as 'breakfast' | 'lunch' | 'dinner',
      authorFirstName: mealPlan.authorFirstName,
      imageUrl: mealPlan.imageUrl,
      storageImageUrl: mealPlan.storageImageUrl,
      userImageUrl: mealPlan.userImageUrl,
      storageImagePath: mealPlan.storageImagePath,
      userImagePath: mealPlan.userImagePath
    })) : [];

  const footer = (
    <div className="flex items-center space-x-2">
      <Checkbox 
        id={`date-${date.toISOString()}`}
        checked={isSelected}
        onCheckedChange={() => onToggle(date)}
        disabled={!hasMealPlan}
      />
      <Label 
        htmlFor={`date-${date.toISOString()}`}
        className={`cursor-pointer ${!hasMealPlan ? 'text-muted-foreground' : ''}`}
      >
        {hasMealPlan ? 'Include in shopping list' : 'No meal to include'}
      </Label>
    </div>
  );

  return (
    <DailyTile
      date={date}
      meals={meals}
      footer={footer}
      className={isSelected ? 'border-primary' : ''}
      showAllMealTypes={true}
      heightMode="flexible"
    />
  );
};

export default ShoppingListTile;
